module.exports = __webpack_public_path__ + "img/login_background-4.4444597d.svg";